<template>
  <b-container class="d-flex flex-column align-items-center justify-content-center mx-0 px-0 p-0 root-layout" fluid>
    <!-- Top Logo -->
    <div>
      <b-img src="@/assets/Figa_reglog.png" class="Figalogo-img" alt="Figalogo"></b-img>
    </div>

    <!-- Card -->
    <b-card body-class="text-center" style="max-width: 70rem; border-radius: 14.4px;" class="mt-4">
      <div class="login-view">
        <!-- Page Icon -->
        <b-img src="@/assets/Administrator-icon.png" class="logo-img" alt="Admin"></b-img>

        <!-- Title -->
        <b-row class="d-flex flex-row align-items-center justify-content-center" no-gutters>
          <b-col>
            <h3 class="text-center text-main-green font-primary font-weight-bold">
              Password Reset
            </h3>

            <h5 class="text-center text-main-green font-primary font-weight-normal">
              Please enter your new password to reset your account access
            </h5>
          </b-col>
        </b-row>

        <!-- Form -->
        <form id="PasswordRest-form" class="">
          <!-- New Password -->
          <b-row class="d-flex flex-row align-items-center justify-content-center" no-gutters>
            <b-col>
              <FormInputGroup groupId="password-group" id="password-group-input" v-model="password"
                :state="passwordError.status" :invalidFeedback="`${passwordError.message}`" label="New Password"
                placeholder="Minimum 6 characters" isRequired :whiteBG="false"
                :type="showPassword ? 'text' : 'password'" form="PasswordRest-form" isAppend>
                <template v-slot:append>
                  <b-button class="px-3 px-md-4 rounded-0" variant="transparent" @click="showPassword = !showPassword">
                    <b-icon :icon="showPassword ? 'eye-slash' : 'eye'" aria-label="Help"></b-icon>
                  </b-button>
                </template>
              </FormInputGroup>
            </b-col>
          </b-row>

          <!-- Confirm Password -->
          <b-row class="d-flex flex-row align-items-center justify-content-center" no-gutters>
            <b-col>
              <FormInputGroup groupId="confirm-password-group" id="confirm-password-group-input"
                v-model="confirmPassword" :state="confirmPasswordError.status"
                :invalidFeedback="`${confirmPasswordError.message}`" label="Confirm Password"
                placeholder="Minimum 6 characters" isRequired :whiteBG="false"
                :type="showConfirmPassword ? 'text' : 'password'" form="PasswordRest-form" isAppend>
                <template v-slot:append>
                  <b-button class="px-3 px-md-4 rounded-0" variant="transparent"
                    @click="showConfirmPassword = !showConfirmPassword">
                    <b-icon :icon="showConfirmPassword ? 'eye-slash' : 'eye'" aria-label="Help"></b-icon>
                  </b-button>
                </template>
              </FormInputGroup>
            </b-col>
          </b-row>

          <!-- Error / Success Message -->
          <b-row v-if="pwdResetError.status !== null" class="d-flex flex-row align-items-center justify-content-center"
            no-gutters>
            <b-col>
              <span :class="pwdResetError.status ? 'text-danger' : 'text-success'" class="text-small text-center">
                {{ this.pwdResetError.message }}
              </span>
            </b-col>
          </b-row>

          <!-- Submit Button -->
          <b-row class="d-flex flex-row align-items-center justify-content-center" no-gutters>
            <b-col class="d-flex flex-row align-items-center justify-content-center align-self-center">
              <FormButton variant="main-green" isBlock isPill
                class="font-weight-normal text-secondary mt-2 login-button" type="submit" :isLoading="isLoader"
                :disabled="isLoader" @click.native="pwdResetFn">
                <span class="text-white">Reset Password</span>
              </FormButton>
            </b-col>
          </b-row>
        </form>
      </div>
    </b-card>
  </b-container>
</template>

<script>
// services
import FormInputGroup from "@/components/Form/FormInputGroup";
import FormButton from "@/components/Form/FormButton";
import { ResetPassword } from "@/services/account.service";

export default {
  name: "ResetPassword",
  components: {
    FormInputGroup,
    FormButton,
  },
  data() {
    return {
      isLoader: false,
      password: null,
      confirmPassword: null,
      showPassword: false,
      showConfirmPassword: false,
      passwordError: {
        status: null,
        message: null,
      },
      confirmPasswordError: {
        status: null,
        message: null,
      },
      pwdResetError: {
        status: null,
        message: null,
      },
    };
  },
  watch: {
    password(value) {
      this.pwdResetError.status = null;
      if (value) {
        if (value.length < 6) {
          this.passwordError.status = false;
          this.passwordError.message =
            "A minimum length of 6 characters needed";
        } else {
          this.passwordError.status = true;
        }
      } else {
        this.passwordError.status = false;
        this.passwordError.message = "Please fill in your password";
      }
    },
    confirmPassword(value) {
      this.pwdResetError.status = null;
      if (value) {
        if (value != this.password) {
          this.confirmPasswordError.status = false;
          this.confirmPasswordError.message = "Passwords do not match";
        } else {
          this.confirmPasswordError.status = true;
        }
      } else {
        this.confirmPasswordError.status = false;
        this.confirmPasswordError.message = "Please fill in confirm password";
      }
    },
  },
  methods: {
    async pwdResetFn() {
      if (
        this.password &&
        this.confirmPassword &&
        this.password == this.confirmPassword
      ) {
        this.pwdResetError.status = null;
        const t = this.$route.query.t;
        let payload = {
          password: this.password,
          t,
        };
        this.isLoader = true;

        ResetPassword(payload)
          .then(async (res) => {
            if (res.data) {
              this.pwdResetError.status = false;
              this.pwdResetError.message = res.data.msg;
              setTimeout(() => this.$router.push("/"), 2000);
            }
          })
          .catch((error) => {
            this.pwdResetError.message = error.response
              ? error.response.data.msg
              : error.message;
            this.pwdResetError.status = true;
          })
          .finally(() => (this.isLoader = false));
      } else {
        this.validateForm();
      }
    },
    validateForm() {
      if (!this.password) {
        this.passwordError.status = false;
        this.passwordError.message = "Please fill in your password";
      } else if (this.password < 6) {
        this.passwordError.status = false;
        this.passwordError.message = "A minimum length of 6 characters needed";
      } else this.passwordError.status = true;

      if (this.confirmPassword != this.password) {
        this.confirmPasswordError.status = false;
        this.confirmPasswordError.message = "Passwords do not match";
      } else this.confirmPasswordError.status = true;
    },
  },
};
</script>

<style scoped>
.root-layout {
  position: relative;
  min-height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #ffe400;
}

.logo-img {
  align-items: center;
  width: 54px;
  height: 54px;
}

.root-layout .Figalogo-img {
  align-items: center;
  width: 180px;
  height: 60px;
}

.login-view {
  padding-left: 70px;
  padding-right: 70px;
  padding-top: 36px;
  padding-bottom: 50px;
  min-width: 30vw;
}

h5 {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  padding-bottom: 25.6px;
  color: #828282;
}

h3 {
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  padding-top: 14px;
  color: #0b9b7d;
}

.login-view .login-button {
  width: 162px;
  height: 50px;
  background: #0b9b7d;
  border-radius: 30px;
}
</style>
